//react imports
import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

//general components

//home page
import HomePage from "./components/homepage/Homepage";

//sign-up and sign-in
//common
import Landing from "./components/signupandsigninflow/common/Landing";
import SessionExpired from "./components/signupandsigninflow/common/SessionExpired";
//studentflow
import One from "./components/signupandsigninflow/studentflow/one/sign-in-and-sign-up.component";
import Two from "./components/signupandsigninflow/studentflow/two/personaldetails.student.component";
import Three from "./components/signupandsigninflow/studentflow/three/educationalandprofile.student.component";
import Four from "./components/signupandsigninflow/studentflow/four/experiencedetails.student.component";
import Dashboard from "./components/signupandsigninflow/studentflow/dashboard/dashboard.component";
//facultyflow
import OnePlacement from "./components/signupandsigninflow/facultyflow/one/sign-in-and-sign-up.placement.component";
import FormPlaced from "./components/signupandsigninflow/facultyflow/formPlaced/formPlaced.component";
import FormEligibility from "./components/signupandsigninflow/facultyflow/formEligibility/formEligibility.component";
import EligibleStudents from "./components/signupandsigninflow/facultyflow/eligibleStudents/eligibleStudents.component";

import Companies from "./components/companiespage/companies.components";
//companiesinfo
import Resources from "./components/resourcespage/resources.component";
//resourcespage

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="home" element={<HomePage />} />
        <Route path="/" element={<Navigate replace to="home" />} />

        <Route path="notfound" element={<SessionExpired />} />

        <Route path="companies" element={<Companies />} />

        <Route path="resources" element={<Resources />} />

        <Route path="signupsignin">
          <Route
            path=""
            element={
              <Landing
                firstBoxText="Student of UG/PG"
                lastBoxText="Faculty/Placement officer"
                middleBoxText="You are....?"
                heading="Sign-in and Sign-Up"
              />
            }
          />
          <Route exact path="studentportal">
            <Route
              exact
              path="one"
              element={
                <One
                  firstSignText="I have an account"
                  secondSignText="I do not have an account"
                  heading="For Students."
                />
              }
            />
            <Route
              exact
              path="one/dashboard"
              element={<Navigate replace to="" />}
            />
            <Route exact path="two" element={<Two />} />
            <Route exact path="three" element={<Three />} />
            <Route exact path="four" element={<Four />} />
          </Route>
          <Route path="facultyportal">
            <Route
              path="one"
              element={
                <OnePlacement
                  firstSignText="Placement Co-ordinator/Officer"
                  heading="For placement officers and co-ordinators."
                />
              }
            />
            <Route path="two" element={<Landing />} />
          </Route>
        </Route>

        <Route path="dashboard">
          <Route exact path="student">
            <Route path="" element={<Dashboard />} />
          </Route>
          <Route exact path="faculty">
            <Route
              path=""
              element={
                <Landing
                  firstBoxText="Eligible Students Form"
                  lastBoxText="Placed Students Form"
                  middleBoxText="You want to...?"
                  heading="Faculty Dashboard"
                />
              }
            />
            <Route exact path="formPlaced" element={<FormPlaced />} />
            <Route exact path="formEligibility" element={<FormEligibility />} />
            <Route
              exact
              path="eligibleStudents"
              element={<EligibleStudents />}
            />
          </Route>
        </Route>

        <Route path="sessionexpired" element={<SessionExpired />} />
      </Routes>
    </Router>
  );
};

export default App;
